import { render, staticRenderFns } from "./CustomerCaseView.vue?vue&type=template&id=3559cf6c&scoped=true"
import script from "./CustomerCaseView.vue?vue&type=script&lang=js"
export * from "./CustomerCaseView.vue?vue&type=script&lang=js"
import style0 from "./CustomerCaseView.vue?vue&type=style&index=0&id=3559cf6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559cf6c",
  null
  
)

export default component.exports